import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { ScrollPanelModule } from 'primeng/scrollpanel';
import { BreadcrumbModule } from 'primeng/breadcrumb';
import { BlockUIModule } from 'primeng/blockui';

import { HeaderModule } from './header/header.module';
import { NavigationModule } from './navigation/navigation.module';
import { FooterComponent } from './footer/footer.component';
import { MainLayoutComponent } from './main/main-layout.component';
import { EmptyLayoutComponent } from './main/empty-layout.component';
import { AppConfigService } from './../../../services/app-config.service';
import { ButtonModule } from 'primeng/button';
import { TreeSelectModule } from 'primeng/treeselect';
import { RadioButtonModule } from 'primeng/radiobutton';
import { SelectButtonModule } from 'primeng/selectbutton';
import { InputSwitchModule } from 'primeng/inputswitch';
import { SidebarModule } from 'primeng/sidebar';
import { AppConfigComponent } from './config/app.config.component';

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    FormsModule,
    ReactiveFormsModule,
    ScrollPanelModule,
    BreadcrumbModule,
    BlockUIModule,
    ButtonModule,
    SidebarModule,
    InputSwitchModule,
    ButtonModule,
    RadioButtonModule,
    SelectButtonModule,
    HeaderModule,
    NavigationModule,
    AppConfigComponent
  ],
  declarations: [
    FooterComponent,
    MainLayoutComponent,
    EmptyLayoutComponent,
  ],
  exports: [
    ScrollPanelModule,
    BlockUIModule,
    HeaderModule,
    NavigationModule,
    FooterComponent,
    MainLayoutComponent,
    TreeSelectModule
  ],
  providers: [AppConfigService]
})
export class SharedLayoutModule { }
